import { createSelector } from '@ngrx/store';
import { compareDesc } from 'date-fns';
import { AppState } from 'src/store';
import { DutyLogEntity } from './duty-log.model';

export const selectAllDutyLogs = (state: AppState) => state.dutyLogs.entities;

export function selectDutyLogById(id: string) {
  return createSelector(selectAllDutyLogs, (dutyLogs) => dutyLogs[id] as DutyLogEntity | undefined);
}

export function selectEmployeeDutyLogs(employeeId: string) {
  return createSelector(selectAllDutyLogs, (dutyLogs) =>
    Object.values(dutyLogs)
      .filter((l) => l != null && l.employeeId === employeeId)
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      .map((e) => e!),
  );
}

export function selectShiftsByStartTimeDesc(employeeId: string) {
  return createSelector(selectEmployeeDutyLogs(employeeId), (dutyLogs) => {
    return (
      dutyLogs
        .filter((dl) => dl.dutyPeriodStartTime != null)
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        .sort((a, b) => compareDesc(a.dutyPeriodStartTime!, b.dutyPeriodStartTime!))
    );
  });
}

export function selectShiftByStartTimeApprox(employeeId: string, startTime: Date) {
  return createSelector(selectEmployeeDutyLogs(employeeId), (dutyLogs) => {
    const shift = dutyLogs
      .filter((dl) => dl.dutyPeriodStartTime != null)
      .find((dl) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const diff = Math.abs(dl.dutyPeriodStartTime!.getTime() - startTime.getTime());
        const withinSkew = diff < 1000;
        return withinSkew;
      });
    return shift;
  });
}
